(ns dre.components.switch
  (:require
   ["antd" :refer [Switch]]))

(defn switch
  [{:keys [value on-change size]}]
  [:> Switch
   {:checked value
    :on-change on-change
    :size size}])
